'use client'

import * as React from 'react'
import { CookiesProvider } from 'react-cookie'
import { PolyfillContext } from 'custom-polyfills/context'
import { PaymentsDialogProvider } from 'payments/components/payments-dialog-wrapper-context'
import { GrowthBookProvider } from 'growthbook'
import { IubendaGdprProvider } from '@repo/analytics-nextjs/iubenda'

import { ReactQueryProvider } from './query-client-provider'

export function Providers({ children }: React.PropsWithChildren) {
  return (
    <CookiesProvider>
      <PolyfillContext>
        <ReactQueryProvider>
          <GrowthBookProvider platform="marketplace">
            <IubendaGdprProvider>
              <PaymentsDialogProvider coordinateIubenda>{children}</PaymentsDialogProvider>
            </IubendaGdprProvider>
          </GrowthBookProvider>
        </ReactQueryProvider>
      </PolyfillContext>
    </CookiesProvider>
  )
}
